import { render, staticRenderFns } from "./HistoricoMaterialesList.vue?vue&type=template&id=c685c78e&scoped=true&"
import script from "./HistoricoMaterialesList.vue?vue&type=script&lang=js&"
export * from "./HistoricoMaterialesList.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoMaterialesList.vue?vue&type=style&index=0&id=c685c78e&lang=scss&scoped=true&"
import style1 from "./HistoricoMaterialesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c685c78e",
  null
  
)

export default component.exports